export default __webpack_public_path__ + "static/media/mixology-mobile-pattern@3x.bc11b62e.png";